import { useState, useMemo } from "react";
import PropTypes from "prop-types";
import Dropdown from "@shared/v2/Dropdown";
import TextInput from "@shared/v2/TextInput";
import FormWrapper from "./form_controls/FormWrapper";

const SuperUserForm = ({ onCancel, onSubmit, roleOptions, formErrors = null }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState(roleOptions[0]);
  const roleDropdownOptions = useMemo(() => roleOptions.map((r) => ({ value: r, label: r })), [roleOptions]);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    onSubmit({ email, password, role });
  };

  const validate = (name) => {
    if (formErrors && formErrors[name]) {
      return "error";
    }
    return null;
  };

  return (
    <FormWrapper formErrors={formErrors} onCancel={onCancel} onSubmit={handleOnSubmit}>
      <TextInput
        label="Email"
        name="email"
        value={email}
        error={validate("email") === "error"}
        onChange={(e) => setEmail(e.target.value)}
      />

      <TextInput
        label="Password"
        name="password"
        type="password"
        value={password}
        error={validate("password") === "error"}
        onChange={(e) => setPassword(e.target.value)}
      />

      <Dropdown
        options={roleDropdownOptions}
        value={roleDropdownOptions.find((o) => o.value === role)}
        label="Role"
        name="role"
        error={validate("role") === "error"}
        onChange={(o) => setRole(o.value)}
      />
    </FormWrapper>
  );
};

SuperUserForm.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  roleOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  formErrors: PropTypes.shape(),
};

export default SuperUserForm;
